/**
 * @param eventName (String) - the name of the GTM event being triggered.
 * @param eventData (Object) - an object containing additional data to be sent to GTM with the event. If not provided, it defaults to an empty object {}.
 */

export function triggerGTMEvent(eventName, eventData = {}) {
  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push({ event: eventName, ...eventData });
}
